/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resolveMerge} from '../api'

export const useMutationResolveMerge = createReactQueryMutationHook('resolveMerge', resolveMerge)
